import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ConnectorsTableAction } from "stores/ConnectorsTableStore/ConnectorsTableAction";
import { ManufacturerTableAction } from "stores/ManufacturerStore/ManufacturerAction";
import { DetailsTableAction } from "stores/ManufacturViewDetailStore/DetailsTableAction";

const mapStateToProps = (state) => {
  return {
    ManufacturerTableList: state.manufacturer.ManufacturerTableList,
    ConnectorsTableList: state.connectors.ConnectorsTableList,
    DetailsTableList: state.DetailsTable.DetailsTableList,
    isloadingManufacturerTable: state.manufacturer.ManufacturerTable,
    isloadingConnectorsTable: state.connectors.ConnectorsTable,
    isloadingDetailsTable: state.DetailsTable.DetailsTable,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getManufacturerTableAction: ManufacturerTableAction.getManufacturerTable,
      getConnectorsTableAction: ConnectorsTableAction.getConnectorsTable,
      getDetailsTableAction: DetailsTableAction.getDetailsTable,
      UdateMapAction: ManufacturerTableAction.UdateMapAction,
      ManufactureEnableDisableAction:
        ManufacturerTableAction.ManufactureEnableDisable,
    },
    dispatch
  );

const ManufacturerStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ManufacturerStore;
